import React, { createContext, useContext, useState, ReactNode } from 'react';
import noop from 'utils/noop';

interface DeleteImageOverlayContextType {
  imgsIdsToDelete: string[];
  setImgsIdsToDelete: (imgsIds: string[]) => void;
}

export const DeleteImageOverlayContext = createContext<DeleteImageOverlayContextType>({
  imgsIdsToDelete: [],
  setImgsIdsToDelete: noop,
});

export const useDeleteImageOverlayContext = () => useContext(DeleteImageOverlayContext);

interface DeleteImageOverlayProviderProps {
  children: ReactNode;
}

export const DeleteImageProvider: React.FC<DeleteImageOverlayProviderProps> = ({ children }) => {
  const [imgsIdsToDelete, setImgsIdsToDelete] = useState<string[]>([]);

  const value: DeleteImageOverlayContextType = {
    imgsIdsToDelete,
    setImgsIdsToDelete,
  };

  return (
    <DeleteImageOverlayContext.Provider value={value}>
      {children}
    </DeleteImageOverlayContext.Provider>
  );
};
